import { useState } from "react"
import { Box } from "theme-ui"
import openIcon from "./selecticon.png"

export const CountsItem = ({ index, item }: any) => {
 const [subIndex, setSubIndex] = useState<number | null>(null)
 const [innerIndex, setInnerIndex] = useState<number | null>(null)
 const [openCards, setOpenCards] = useState<number[]>([])
 const [rotate, setRotate] = useState<boolean>(false)
 const toggleCard = (index: any) => {
  if (openCards.includes(index)) {
   setOpenCards(openCards.filter((cardIndex) => cardIndex !== index))
  } else {
   setOpenCards([...openCards, index])
  }
  setRotate(!rotate)
 }

 return (
  <div key={index} className="w-full mx-2">
   <Box bg="highlight" className=" w-full py-3 rounded">
    <Box
     bg="gray"
     color="text-black"
     style={{ margin: "0 auto" }}
     className="flex justify-between items-center w-[96%] rounded mx-auto px-2 py-3"
    >
     <h1>{item.heading}</h1>
     <div
      onClick={() => toggleCard(index)}
      className="h-6 w-6 rounded bg-dark-yellow flex items-center justify-center cursor-pointer"
     >
      <img className={`${rotate ? "rotate-360" : "rotate-180"}`} src={openIcon} alt="icon" />
     </div>
    </Box>
    <div>
     {openCards.includes(index) && (
      <div>
       {item.submenu.map((sub: any, index: number) => (
        <Box key={index} bg="highlight" color="text-black">
         <div
          key={index}
          className={`border-b-[1.5px] border-light-gray pb-3 w-full animate-move-card ${
           index === item?.submenu?.length - 1 ? "border-none pb-0" : ""
          }`}
         >
          {sub.info !== "" ? (
           <div className="flex w-full justify-between px-4 ">
            <h1 className="w-[50%]">{sub.heading}</h1>
            <h1 className="w-[50%]">{sub.info}</h1>
           </div>
          ) : (
           <div>
            <Box
             bg="gray"
             color="text-black"
             style={{ margin: "16px  auto 0px auto" }}
             className="flex justify-between items-center w-[96%] rounded mx-auto px-2 py-3 "
            >
             <h1>{sub.heading}</h1>
             <div
              onClick={() => setSubIndex((prev) => (prev ? null : index))}
              className="h-6 w-6 rounded bg-dark-yellow flex items-center justify-center cursor-pointer"
             >
              <img
               className={`${subIndex === index ? "rotate-360" : "rotate-180"}`}
               src={openIcon}
               alt="icon"
              />
             </div>
            </Box>
            {subIndex === index && (
             <div>
              {sub.submenu.map((item: any, index: number) => (
               <div
                key={index}
                className={`border-b-[1.5px] border-light-gray pb-3 animate-move-card  ${
                 index === sub.submenu.length - 1 ? "border-none pb-0" : ""
                }`}
               >
                {item.info !== "" ? (
                 <div className="flex  w-full justify-between  px-4 ">
                  <h1 className="w-[50%]">{item.heading}</h1>
                  <h1 className="w-[50%]">{item.info}</h1>
                 </div>
                ) : (
                 <div>
                  <Box
                   bg="gray"
                   color="text-black"
                   style={{ margin: "16px  auto 0px auto" }}
                   className="flex justify-between items-center w-[96%] rounded mx-auto px-2 py-3 mt-3 mb-2"
                  >
                   <h1>{item.heading}</h1>
                   <div
                    onClick={() => setInnerIndex((prev) => (prev ? null : index))}
                    className="h-6 w-6 rounded bg-dark-yellow flex items-center justify-center cursor-pointer"
                   >
                    <img
                     className={`${innerIndex === index ? "rotate-360" : "rotate-180"}`}
                     src={openIcon}
                     alt="icon"
                    />
                   </div>
                  </Box>
                  {innerIndex === index &&
                   item.submenu.map((item: any, index: number) => {
                    return (
                     <div
                      key={index}
                      className={`border-b-[1.5px] border-light-gray pb-3 animate-move-card ${
                       index === item.submenu.length - 1 ? "border-none pb-0" : ""
                      }`}
                     >
                      {item.info !== "" ? (
                       <div className="flex w-full justify-between  px-4 ">
                        <h1 className="w-[50%]">{item.heading}</h1>
                        <h1 className="w-[50%]">{item.info}</h1>
                       </div>
                      ) : (
                       ""
                      )}
                     </div>
                    )
                   })}
                 </div>
                )}
               </div>
              ))}
             </div>
            )}
           </div>
          )}
         </div>
        </Box>
       ))}
      </div>
     )}
    </div>
   </Box>
  </div>
 )
}
